/* Galería de producto: deslizar hacia el lado (móvil) y flechas (escritorio). Sin dependencias. */
(function () {
  'use strict';

  function init(root) {
    var main = root.querySelector('.vy-gallery__main');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    if (!main || thumbs.length < 2) return;

    function current() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function go(n) {
      var i = (n + thumbs.length) % thumbs.length;
      thumbs[i].click();
      if (thumbs[i].scrollIntoView) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    /* Deslizar con el dedo */
    var x0 = null;
    var y0 = null;
    main.style.touchAction = 'pan-y';
    main.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX;
      y0 = t.clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(current() + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* Flechas visibles */
    function arrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', dir < 0 ? 'Imagen anterior' : 'Imagen siguiente');
      b.textContent = dir < 0 ? '‹' : '›';
      b.style.cssText = 'position:absolute;top:50%;' + (dir < 0 ? 'left' : 'right') + ':10px;transform:translateY(-50%);' +
        'width:40px;height:40px;border:0;border-radius:50%;background:rgba(255,255,255,.88);color:#151719;' +
        'font-size:26px;line-height:1;cursor:pointer;z-index:3;display:flex;align-items:center;justify-content:center;' +
        'box-shadow:0 1px 6px rgba(0,0,0,.18);padding:0 0 3px';
      b.addEventListener('click', function () { go(current() + dir); });
      main.appendChild(b);
    }
    arrow(-1);
    arrow(1);

    /* Teclado */
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
    });
  }

  function boot() { document.querySelectorAll('[data-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
